import React from "react";
import TagAnalysis from "../extras/testing/tag.analysis";

export default function Tags() {
  return <TagAnalysis />;
}
